import { RootState } from '@/store/types/RootState';

export const selectClaimSetClaimListDataRequestsStates = (state: RootState) =>
  state.claimSetClaimList.dataRequestsStates;

export const selectBenefitSectionListDataIsLoadingByClaimId =
  (claimId: string) =>
  (state: RootState): boolean =>
    state.claimSetClaimList.dataRequestsStates.benefitSectionListData[claimId]?.isLoading ?? true;

export const selectClaimSetClaimListPagination = (state: RootState) => state.claimSetClaimList.data.pagination;

export const selectClaimSetClaimListData = (state: RootState) => state.claimSetClaimList.data.listings;

export const selectClaimSetClaimById = (id: number) => (state: RootState) =>
  state.claimSetClaimList.data.listings.find((claim) => claim.id === id);

export const selectClaimData = (id: number) => (state: RootState) =>
  state.claimSetClaimList.data.listings.find((claim) => claim.id === id);

export const selectCoverageDataByClaimId = (id: number) => (state: RootState) =>
  state.claimSetClaimList.coverageData?.[id];

export const selectPolicyDataByClaimId = (id: number) => (state: RootState) => state.claimSetClaimList.policyData?.[id];

export const selectBenefitDataByClaimId = (id: number) => (state: RootState) =>
  state.claimSetClaimList.benefitData?.[id];
